import {
  MessageReceiptStatus,
  MessageDirection,
} from '@/models/conversations/conversations.js'

export const CONSTANTS = {
  // Conversation generation settings
  conversation: {
    messagesCount: {
      min: 1,
      max: 100,
    },
    unreadMessagesCount: {
      min: 0,
      max: 3,
    },
    dateRange: {
      years: 1,
      recentDays: 7,
    },
    seedCount: 60,
    unknownSenderSeedCount: 5,
    assignedUserSeedCount: 10,
    patientSeedCount: 20,
  },

  // Message generation settings
  message: {
    defaultType: 'text' as const,
    types: ['text', 'image', 'document', 'audio', 'video'] as const,
    directions: Object.values(MessageDirection),
    countPerConversation: {
      min: 5,
      max: 15,
    },
    timeOffsetMinutes: {
      min: 1,
      max: 120,
    },
  },

  // Participant generation settings
  participant: {
    types: ['client', 'system', 'employee', 'bot'] as const,
    internalIdRange: {
      min: 1000,
      max: 9999,
    },
    additionalParticipantsCount: {
      min: 0,
      max: 2,
    },
    defaultCountryCode: 'US' as const,
  },

  // Conversation message (send to client) settings
  conversationMessage: {
    clientIdRange: {
      max: 100000,
    },
    defaultChannel: 'sms' as const,
    simulateError: false,
    simulateResendError: false,
  },

  // Message receipt settings
  messageReceipt: {
    statuses: Object.values(MessageReceiptStatus),
    defaultStatus: MessageReceiptStatus.Sent,
  },

  // Media attachment settings
  media: {
    countPerMessage: { min: 1, max: 3 },
    sampleFiles: [
      {
        file_name: 'xray-results.pdf',
        mime_type: 'application/pdf',
        media_type: 'document',
      },
      {
        file_name: 'pet-photo.jpg',
        mime_type: 'image/jpeg',
        media_type: 'image',
      },
      {
        file_name: 'vaccination-record.png',
        mime_type: 'image/png',
        media_type: 'image',
      },
      {
        file_name: 'lab-report.pdf',
        mime_type: 'application/pdf',
        media_type: 'document',
      },
      {
        file_name: 'wound-photo.jpg',
        mime_type: 'image/jpeg',
        media_type: 'image',
      },
      {
        file_name: 'prescription.pdf',
        mime_type: 'application/pdf',
        media_type: 'document',
      },
      {
        file_name: 'skin-condition.png',
        mime_type: 'image/png',
        media_type: 'image',
      },
      {
        file_name: 'discharge-notes.pdf',
        mime_type: 'application/pdf',
        media_type: 'document',
      },
    ],
    sampleImageUrls: ['/pcloud/mock/dog.jpeg', '/pcloud/mock/dog-2.jpeg'],
  },
} as const
